<template>
  <v-app-bar dark app elevation="0" :color="color" class="header_wrapper">
    <v-toolbar-title hide-on-scroll class="title">
      <h3>La Micutu</h3>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items align="center">
      <div class="toolbar-element-container">
        <v-btn text router-link to="/">Home</v-btn>
      </div>
      <div class="toolbar-element-container">
        <v-btn text>Articles</v-btn>
      </div>
      <div class="toolbar-element-container">
        <v-btn text router-link to="video-categories">Videos</v-btn>
      </div>
      <div class="toolbar-element-container">
        <v-btn text>Photos</v-btn>
      </div>
    </v-toolbar-items>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-chip class="ma-2" :color="color" label v-on="on">
          <v-icon left>mdi-account-circle-outline</v-icon>
          {{ $auth.user().username }}
        </v-chip>
      </template>
      <v-list dense>
        <v-list-item @click="logout">
          <v-list-item-content class="justify-center"
            >Logout</v-list-item-content
          >
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: 'AppHeader',

  props: {
    color: { type: String }
  },

  methods: {
    logout() {
      this.$auth.logout()
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  text-shadow: 0px 4px 3px rgba(0, 0, 0, 0.4), 0px 8px 13px rgba(0, 0, 0, 0.1),
    0px 18px 23px rgba(0, 0, 0, 0.1);
}
.toolbar-element-container {
  display: flex;
  align-items: center;
}
.header_wrapper {
  z-index: 700 !important;
}
</style>
